// Organisms - великі елементи інтерфейсу
// Приклад: SearchBar, ProductList, UserProfile тощо

export { default as Header } from './Header';
export { default as Footer } from './Footer';
export { default as Main } from './Main';
export { default as Hero } from './Hero';

// Portfolio (Figma design: GSAP + SCSS)
export { default as AnimatedBackground } from './AnimatedBackground';
export { default as Navbar } from './Navbar';
export { default as AboutSection } from './AboutSection';
export { default as ServicesSection } from './ServicesSection';
export { default as ProjectsSection } from './ProjectsSection';
export { default as ExperienceSection } from './ExperienceSection';
export { default as FixedCtaButton } from './FixedCtaButton';
export { default as Form } from './Form';
export { default as ContactModal } from './ContactModal';
export { default as ContactDrawer } from './ContactModal/ContactDrawer';
export { ContactModalProvider, useContactModal } from './ContactModal/ContactModalContext';

export type { HeroProps, HeroStat } from './Hero/types';
export type { NavItem, HeaderData } from './Header/header';
export type { FormProps, FormFieldConfig } from './Form/types';
